// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.markertd[data-v-1a8cd098] {\n  background: #fff;\n  border: 0px;\n  width: 32px;\n}\ntr:hover .markertd .mark[data-v-1a8cd098] {\n  display: block;\n  /* opacity: 1;\n  transition: 0.8s; */\n}\ntr .markertd .mark[data-v-1a8cd098] {\n  display: none;\n  /* opacity: 0; */\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
